import { render, staticRenderFns } from "./RowDeal.vue?vue&type=template&id=fbd2f768&scoped=true&"
import script from "./RowDeal.vue?vue&type=script&lang=ts&"
export * from "./RowDeal.vue?vue&type=script&lang=ts&"
import style0 from "./RowDeal.vue?vue&type=style&index=0&id=fbd2f768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2f768",
  null
  
)

export default component.exports